import { callBffApi } from "./axios";
import { IBusinessFunctionLead } from "../redux/slices/business-functions";

export const businessFunctionsService = {
  fetchBusinessFunctionLeads: async () => {
    const response = await callBffApi<{ data: IBusinessFunctionLead[] }>("get", "/business-function-leads");
    return response.data;
  },
};
